import Entity from '../entity';

export default class ManufacturerModel extends Entity<number> {
    manufacturer_id: number;
    model: string;
    user_id: number;
    created_date: number;
    updated_date: number;
}
